var Shopify = Shopify || {};
Shopify.money_format = "${{amount}}";
Shopify.formatMoney = function(cents, format) {
  if (typeof cents == 'string') { cents = cents.replace('.',''); }
  var value = '';
  var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
  var formatString = (format || this.money_format);

  function defaultOption(opt, def) {
    return (typeof opt == 'undefined' ? def : opt);
  }
  function formatWithDelimiters(number, precision, thousands, decimal) {
    precision = defaultOption(precision, 2);
    thousands = defaultOption(thousands, ',');
    decimal   = defaultOption(decimal, '.');
    if (isNaN(number) || number == null) { return 0; }
    number = (number/100.0).toFixed(precision);
    var parts   = number.split('.'),
        dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands),
        cents   = parts[1] ? (decimal + parts[1]) : '';
    return dollars + cents;
  }

  switch(formatString.match(placeholderRegex)[1]) {
    case 'amount':
      value = formatWithDelimiters(cents, 2);
      break;
    case 'amount_no_decimals':
      value = formatWithDelimiters(cents, 0);
      break;
    case 'amount_with_comma_separator':
      value = formatWithDelimiters(cents, 2, '.', ',');
      break;
    case 'amount_no_decimals_with_comma_separator':
      value = formatWithDelimiters(cents, 0, '.', ',');
      break;
  }
  return formatString.replace(placeholderRegex, value);
};

if (!customElements.get('sticky-atc')) {
  class stickyAtc extends HTMLElement {
    constructor() {
      super();
      this.listeners = [];
      this.frame = null;
    }

    connectedCallback() {
      if (this.initialized || this.dataset.discontinued === 'true') return;
      this.productSection = document.querySelector('[data-section-type="product"]');
      if (!this.productSection) return;
      this.listen(document, 'shopify:section:load', (event) => {
        const target = event.target;
        const section = target.matches?.('[data-section-type="product"]') ? target : target.querySelector?.('[data-section-type="product"]');
        if (!section) return;
        this.disconnectedCallback();
        this.connectedCallback();
      });
      let sectionSettings = {};
      try { sectionSettings = JSON.parse(this.productSection.getAttribute('data-section-settings') || '{}'); }
      catch (error) {}
      this.hidden = sectionSettings.enableStickyAtc === false;
      if (this.hidden) {
        this.initialized = true;
        return;
      }
      this.mainHeader = document.querySelector('#shopify-section-header');
      this.mainATCWrapper = this.productSection.querySelector('.product--button-wrapper');
      if (!this.mainATCWrapper) {
        this.initialized = true;
        return;
      }
      this.mainATC = this.mainATCWrapper.querySelector('.ProductForm__AddToCart');
      this.mainQuantityInput = this.productSection.querySelector('form[action*="/cart/add"] [name="quantity"]');
      this.atcBtn = this.querySelector('[data-atc]');
      this.priceEl = this.querySelector('[data-sticky-price]');
      this.qtyInput = this.querySelector('[data-qty-input]');
      this.qtyMinus = this.querySelector('[data-qty-minus]');
      this.qtyPlus = this.querySelector('[data-qty-plus]');
      this.isCfp = this.dataset.cfp === 'true';
      const json = this.querySelector('[data-variant-json]');
      try { this.variants = JSON.parse(json ? json.textContent : '[]'); }
      catch (error) { this.variants = []; }
      const selected = this.productSection.querySelector('[name="id"]');
      this.currentVariant = this.variants.find((variant) => String(variant.id) === selected?.value) || null;
      const discontinued = this.productSection.querySelector('[data-variants-discontinued-json]');
      try { this.discontinuedMap = JSON.parse(discontinued ? discontinued.textContent : '{}'); }
      catch (error) { this.discontinuedMap = {}; }
      this.initialized = true;

      this.listen(this.productSection, 'variant:changed', (event) => {
        const variant = event.detail && event.detail.variant;
        if (variant && !this.variants.some((item) => item.id === variant.id)) return;
        this.currentVariant = variant || null;
        this.updateVariant();
      });
      this.listen(window, 'scroll', () => this.schedule(), { passive: true });
      this.listen(window, 'resize', () => this.schedule());
      if (this.atcBtn) this.listen(this.atcBtn, 'click', () => {
        if (!this.mainATC || this.mainATC.disabled || !this.currentVariant || this.isDiscontinued) return;
        if (this.qtyInput) this.syncQtyToMain(this.qtyInput.value);
        this.mainATC.click();
      });
      if (this.qtyInput) {
        if (this.qtyMinus) this.listen(this.qtyMinus, 'click', () => this.syncQtyToMain(this.quantity(this.qtyInput.value) - 1));
        if (this.qtyPlus) this.listen(this.qtyPlus, 'click', () => this.syncQtyToMain(this.quantity(this.qtyInput.value) + 1));
        this.listen(this.qtyInput, 'change', () => this.syncQtyToMain(this.qtyInput.value));
      }
      if (this.mainQuantityInput) {
        this.listen(this.mainQuantityInput, 'input', () => this.syncQtyFromMain());
        this.listen(this.mainQuantityInput, 'change', () => this.syncQtyFromMain());
      }
      this.observer = new MutationObserver(() => {
        this.syncQtyFromMain();
        this.updateAvailability();
      });
      if (this.mainATC) this.observer.observe(this.mainATC, { attributes: true, attributeFilter: ['disabled', 'aria-disabled'] });
      if (this.mainQuantityInput) this.observer.observe(this.mainQuantityInput, { attributes: true, attributeFilter: ['value', 'min', 'max'] });
      this.syncQtyFromMain();
      this.updateVariant();
    }

    disconnectedCallback() {
      this.listeners.forEach(([target, type, handler, options]) => target.removeEventListener(type, handler, options));
      this.listeners = [];
      if (this.observer) this.observer.disconnect();
      if (this.frame !== null) window.cancelAnimationFrame(this.frame);
      this.frame = null;
      this.initialized = false;
    }

    listen(target, type, handler, options) {
      target.addEventListener(type, handler, options);
      this.listeners.push([target, type, handler, options]);
    }

    quantity(value) {
      const minimum = Math.max(parseInt(this.mainQuantityInput?.min, 10) || 1, 1);
      const maximum = parseInt(this.mainQuantityInput?.max, 10);
      const result = Math.max(parseInt(value, 10) || minimum, minimum);
      return Number.isFinite(maximum) ? Math.min(Math.max(maximum, minimum), result) : result;
    }

    syncQtyFromMain() {
      if (!this.qtyInput || !this.mainQuantityInput) return;
      this.qtyInput.value = this.quantity(this.mainQuantityInput.value);
    }

    syncQtyToMain(value) {
      if (!this.mainQuantityInput) return;
      const quantity = this.quantity(value);
      if (this.qtyInput) this.qtyInput.value = quantity;
      this.mainQuantityInput.value = quantity;
      this.mainQuantityInput.dispatchEvent(new Event('change', { bubbles: true }));
    }

    updateVariant() {
      this.isDiscontinued = !!(this.currentVariant && this.discontinuedMap[this.currentVariant.id]?.discontinued);
      if (!this.isCfp && this.priceEl) {
        this.priceEl.hidden = !this.currentVariant;
        if (this.currentVariant) this.updatePrice(this.currentVariant);
      }
      this.updateAvailability();
      this.schedule();
    }

    updateAvailability() {
      if (!this.atcBtn || this.isCfp) return;
      const languages = window.languages || {};
      this.atcBtn.disabled = !this.currentVariant || !this.currentVariant.available || this.isDiscontinued || !this.mainATC || this.mainATC.disabled || this.mainATC.getAttribute('aria-disabled') === 'true';
      this.atcBtn.textContent = !this.currentVariant ? (languages.productFormUnavailable || 'UNAVAILABLE') : this.currentVariant.available ? (languages.productFormAddToCart || 'ADD TO CART') : (languages.productFormSoldOut || 'SOLD OUT');
    }

    updatePrice(variant) {
      const price = Shopify.formatMoney(variant.price, window.theme?.moneyFormat);
      const compareAt = variant.compare_at_price;
      if (compareAt && compareAt > variant.price) {
        const comparePrice = Shopify.formatMoney(compareAt, window.theme?.moneyFormat);
        this.priceEl.innerHTML = `<span class="sticky-atc-bar__price--sale">${price}</span><span class="sticky-atc-bar__price--compare">${comparePrice}</span>`;
      } else {
        this.priceEl.innerHTML = `<span class="sticky-atc-bar__price--regular">${price}</span>`;
      }
    }

    schedule() {
      if (this.frame !== null) return;
      this.frame = window.requestAnimationFrame(() => {
        this.frame = null;
        if (!this.isConnected) return;
        if (!this.mainATCWrapper || this.isDiscontinued) {
          this.classList.remove('active');
          return;
        }
        const headerHeight = this.mainHeader ? this.mainHeader.clientHeight : 0;
        const threshold = this.classList.contains('active') ? headerHeight + 4 : headerHeight - 4;
        this.classList.toggle('active', this.mainATCWrapper.getBoundingClientRect().bottom <= threshold);
      });
    }
  }
  customElements.define('sticky-atc', stickyAtc);
}
